import { IUser } from "@/shared/model/user-management/user.model";

export interface IClient {
  id?: number;
  firstName?: string;
  lastName?: string;
  mail?: string;
  phoneNb?: string;
  gender?: string;
  creationDate?: Date;
  currency?: string;
  manager?: IUser;
  progressStatus?: number;
  clientRole?: string;
  confidential?: boolean;
  stopSms?: boolean;
  stopEmail?: boolean;
  selected?: boolean;
  phoneNbIsValid?: string;
  phoneNbIsGoodFormat?: string;
  conversionFromProspectToClientDate?: Date;
  matchedAdvisor?: string;
}

export class Client implements IClient {
  constructor(
    public id?: number,
    public firstName?: string,
    public lastName?: string,
    public mail?: string,
    public phoneNb?: string,
    public gender?: string,
    public creationDate?: Date,
    public currency?: string,
    public manager?: IUser,
    public progressStatus?: number,
    public clientRole?: string,
    public confidential?: boolean,
    public stopSms?: boolean,
    public stopEmail?: boolean,
    public selected?: boolean,
    public phoneNbIsValid?: string,
    public phoneNbIsGoodFormat?: string,
    public conversionFromProspectToClientDate?: Date,
    public matchedAdvisor? : string
  ) {}
}
